//@flow
import React from 'react';

import {Button, makeStyles, TableCell} from '@material-ui/core';
import {VisibilityOffOutlined, VisibilityOutlined} from '@material-ui/icons';
import {
  useEnabledVariantContext,
  useProductVariantContext,
} from '../../../context/productVariant';
import {useProductVariantRequestContext} from '../../../context/productVariantRequest';

const useStyles = makeStyles(theme => ({
  button: {
    paddingInline: '2rem',
    pointerEvents: 'all',
  },
}));

export default function VariantOffButtonCell() {
  const classes = useStyles();

  const variant = useProductVariantContext();
  const [enabled, setEnabled] = useEnabledVariantContext();
  const request = useProductVariantRequestContext();

  const handleClick = () => {
    setEnabled(!enabled);
    request.setEnabled(variant.id, !enabled);
  };

  return (
    <TableCell component="th" scope="row" align="center">
      <Button className={classes.button} onClick={handleClick}>
        {enabled ? (
          <VisibilityOffOutlined color="error" />
        ) : (
          <VisibilityOutlined color="error" />
        )}
      </Button>
    </TableCell>
  );
}
